import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7382bb28"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "settings-block" }
const _hoisted_2 = { class: "is-block-mobile is-flex-tablet is-flex-direction-row is-justify-content-space-between disabled" }
const _hoisted_3 = { class: "mr-3" }
const _hoisted_4 = { class: "title my-0" }
const _hoisted_5 = { class: "description" }
const _hoisted_6 = { class: "setting-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ld_button = _resolveComponent("ld-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.title), 1),
        _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.description), 1),
        _createElementVNode("div", _hoisted_6, [
          _renderSlot(_ctx.$slots, "default", {}, undefined, true)
        ])
      ]),
      _createElementVNode("div", null, [
        _createVNode(_component_ld_button, {
          id: "changeValue",
          rounded: "",
          type: "submit",
          blue: "",
          medium: "",
          loading: _ctx.loading,
          disabled: _ctx.disabled,
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('save')))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('common.save')), 1)
          ]),
          _: 1
        }, 8, ["loading", "disabled"])
      ])
    ])
  ]))
}